<div class="bundle-carousel-slide" [ngClass]="{'active': isActive, 'no-price': !bundle?.totalPrice}">
  <gen-message [messages]="errorMessages"></gen-message>

  <cx-spinner *ngIf="loading === GenLoadingEnum.Loading" class="spinner-overlay"></cx-spinner>

  <gen-bundle-corner-item [bundle]="bundle"></gen-bundle-corner-item>

  <div class="bundle-carousel-items">
    <gen-bundle-carousel-item *ngFor="let item of bundle.items; trackBy: trackByProduct;" [product]="item" [ngClass]="{
        'items-size-one': bundle.items.length === 1,
        'items-size-multiply-two': bundle.items.length % 2 ===0,
        'items-size-multiply-two-plus-one': bundle.items.length % 2 === 1
      }"
    ></gen-bundle-carousel-item>
  </div>
  <gen-bundle-corner-item [isSummary]="true" [bundle]="bundle"
    (addBundleToTheCart)="addBundleToTheCart.emit($event)"></gen-bundle-corner-item>
</div>